// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"9144de02","294":"a93cb11d","323":"e7052e14","332":"e19db592","375":"cc586f01","421":"1cc274c5","451":"d8148a64","453":"f8220223","487":"fbbe0092","496":"df1f3d9e","516":"d0bed19d","591":"54da50db","619":"520fc20a","773":"028ffdf6","857":"36f5f917","959":"b41a7410"}[chunkId] + ".chunk.js";
};